import { EnvKey } from "@ruminati/types/env"

import { CURRENT_ORGANISATION_ID_COOKIE_SUFFIX, CURRENT_USER_ID_COOKIE_SUFFIX, SESSION_COOKIE_SUFFIX, CURRENT_PROVIDER_COOKIE_SUFFIX } from "@ruminati/constants"

export function getCookieNameForEnvBySuffix (
  cookieSuffix: typeof CURRENT_USER_ID_COOKIE_SUFFIX | typeof CURRENT_ORGANISATION_ID_COOKIE_SUFFIX | typeof SESSION_COOKIE_SUFFIX | typeof CURRENT_PROVIDER_COOKIE_SUFFIX,
  envKey: EnvKey
) {
  return `ruminati_${envKey === 'prod' ? '' : `${envKey}_`}${cookieSuffix}`
}

export function USER_ID_COOKIE_FOR_ENV (envKey: EnvKey): string {
  return getCookieNameForEnvBySuffix(CURRENT_USER_ID_COOKIE_SUFFIX, envKey)
}

export function USERS_CURRENT_ORG_ID_COOKIE_FOR_ENV (envKey: EnvKey): string {
  return getCookieNameForEnvBySuffix(CURRENT_ORGANISATION_ID_COOKIE_SUFFIX, envKey)
}

export function USERS_SESSION_COOKIE_FOR_ENV (envKey: EnvKey): string {
  return getCookieNameForEnvBySuffix(SESSION_COOKIE_SUFFIX, envKey)
}

export function USERS_CURRENT_PROVIDER_COOKIE_FOR_ENV (envKey: EnvKey): string {
  return getCookieNameForEnvBySuffix(CURRENT_PROVIDER_COOKIE_SUFFIX, envKey)
}
